////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const exportData = {
	[ActionsTypes.POST_EXPORT_DATAS]: (state) =>
		update(state, {
			exportData: {
				isLoading: {
					$set: true,
				},
				isExported: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_EXPORT_DATAS_SUCCESS]: (state, _payload) => {
		return update(state, {
			exportData: {
				isLoading: {
					$set: false,
				},
				isExported: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_EXPORT_DATAS_FAILURE]: (state, payload) =>
		update(state, {
			exportData: {
				isLoading: {
					$set: false,
				},
				isExported: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_EXPORT_DATAS_BY_EMAIL]: (state) =>
		update(state, { exportDataByEmail: { isLoading: { $set: true }, status: { $set: 'idle' } } }),
	[ActionsTypes.POST_EXPORT_DATAS_BY_EMAIL_SUCCESS]: (state) =>
		update(state, { exportDataByEmail: { isLoading: { $set: false }, status: { $set: 'success' } } }),
	[ActionsTypes.POST_EXPORT_DATAS_BY_EMAIL_FAILURE]: (state) =>
		update(state, { exportDataByEmail: { isLoading: { $set: false }, status: { $set: 'error' } } }),
	[ActionsTypes.RESET_EXPORT_DATAS_BY_EMAIL]: (state) =>
		update(state, { exportDataByEmail: { isLoading: { $set: false }, status: { $set: 'idle' } } }),
}

export default exportData
